// Review-only gallery of explainers (route /__explainers). Owned by the explainers build agent.
import { ExplainerGallery } from './Gallery';

export default function GalleryPage() {
  return <ExplainerGallery />;
}
